import { Buffer } from 'buffer';
import decode from 'heic-decode';

const heicToJpeg = async (imageFile) => {
    const arrayBuffer = await imageFile.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer); // Create a Node.js Buffer from the ArrayBuffer
    const { width, height, data } = await decode({ buffer }); // Decode the HEIC file

    const imageDataArray = new Uint8ClampedArray(data);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    const imageData = new ImageData(imageDataArray, width, height);
    ctx.putImageData(imageData, 0, 0);

    const jpegBlob = await new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error('Canvas toBlob failed.'));
                }
            },
            'image/jpeg',
            0.9 // Quality parameter
        );
    });

    return new File([jpegBlob], imageFile.name.replace(/\.[^/.]+$/, '.jpeg'), {
        type: 'image/jpeg',
    });
};

export default heicToJpeg;
